// Stellarium Web - Copyright (c) 2022 - Stellarium Labs SRL
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

// [guanxing patch] M-SW59：农历 ↔ 公历换算（出生表单「公历/农历」拨钮的数据底座）。
// 历表 LUNAR_INFO 为 1900–2100 每年一个十六进制编码：低 4 位 = 该年闰月月份
// （0 = 无闰月），0x10 位起自高到低依次是 1~12 月的大小月（1 = 30 天，0 = 29 天），
// 0x10000 位 = 闰月大小。该表逐字取自开源库 solarlunar@2.0.7（ISC License，
// https://www.npmjs.com/package/solarlunar，源自 jjonline/calendar.js），已在
// THIRD_PARTY_NOTICES.md 登记出处与许可；换算算法与其同源（天数偏移法），
// 本文件只保留表单所需的最小 API（查闰月 / 月日天数 / 农历→公历），干支、
// 节气、生肖等未引入。
//
// 覆盖边界：农历 1900 年正月初一 = 公历 1900-01-31；表单年份下拉为
// 1900~当前年，全部落在历表有效域内。

// 农历月份汉语名（nStr3 口径）：正月、二月…十月、冬月、腊月
const MONTH_NAMES = ['正', '二', '三', '四', '五', '六', '七', '八', '九', '十', '冬', '腊']

/* eslint-disable */
// 历表数据区：逐字拷贝，不改格式不重排，保证与上游逐字节可 diff
const LUNAR_INFO = [0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2,//1900-1909
  0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977,//1910-1919
  0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970,//1920-1929
  0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,//1930-1939
  0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557,//1940-1949
  0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5b0, 0x14573, 0x052b0, 0x0a9a8, 0x0e950, 0x06aa0,//1950-1959
  0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0,//1960-1969
  0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b6a0, 0x195a6,//1970-1979
  0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570,//1980-1989
  0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x05ac0, 0x0ab60, 0x096d5, 0x092e0,//1990-1999
  0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5,//2000-2009
  0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,//2010-2019
  0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530,//2020-2029
  0x05aa0, 0x076a3, 0x096d0, 0x04afb, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45,//2030-2039
  0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0,//2040-2049
  0x14b63, 0x09370, 0x049f8, 0x04970, 0x064b0, 0x168a6, 0x0ea50, 0x06b20, 0x1a6c4, 0x0aae0,//2050-2059
  0x092e0, 0x0d2e3, 0x0c960, 0x0d557, 0x0d4a0, 0x0da50, 0x05d55, 0x056a0, 0x0a6d0, 0x055d4,//2060-2069
  0x052d0, 0x0a9b8, 0x0a950, 0x0b4a0, 0x0b6a6, 0x0ad50, 0x055a0, 0x0aba4, 0x0a5b0, 0x052b0,//2070-2079
  0x0b273, 0x06930, 0x07337, 0x06aa0, 0x0ad50, 0x14b55, 0x04b60, 0x0a570, 0x054e4, 0x0d160,//2080-2089
  0x0e968, 0x0d520, 0x0daa0, 0x16aa6, 0x056d0, 0x04ae0, 0x0a9d4, 0x0a4d0, 0x0d150, 0x0f252,//2090-2099
  0x0d520]//2100
/* eslint-enable */

// 农历 y 年闰几月（0 = 该年无闰月），y ∈ [1900, 2100]
export function leapMonth (y) {
  return (LUNAR_INFO[y - 1900] & 0xf)
}

// 农历 y 年闰月天数（无闰月返回 0；29 或 30）
export function leapDays (y) {
  if (leapMonth(y)) {
    return ((LUNAR_INFO[y - 1900] & 0x10000) ? 30 : 29)
  }
  return 0
}

// 农历 y 年 m 月（1~12，非闰月）天数：29 或 30
export function lunarMonthDays (y, m) {
  if (m > 12 || m < 1) return -1
  return ((LUNAR_INFO[y - 1900] & (0x10000 >> m)) ? 30 : 29)
}

// 农历 y 年一整年总天数（12 个月 + 可能的闰月）
export function lunarYearDays (y) {
  let sum = 348
  for (let i = 0x8000; i > 0x8; i >>= 1) {
    sum += ((LUNAR_INFO[y - 1900] & i) ? 1 : 0)
  }
  return (sum + leapDays(y))
}

// 农历 y 年 m 月（含闰月口径）的天数。isLeap=true 时 m 必须恰为该年闰月，
// 否则返回 -1（调用方视作非法组合）。
export function lunarDaysOf (y, m, isLeap) {
  if (isLeap) {
    if (leapMonth(y) !== m) return -1
    return leapDays(y)
  }
  return lunarMonthDays(y, m)
}

// 农历 y 年的月下拉选项（按历序：正月…冬月、腊月，闰月插在其对应月之后）。
// 返回 [{ value, text, month, isLeap, days }]；value 是字符串编码：
// 纯数字 '5' = 五月，'5l' = 闰五月（l 后缀表闰，避开与数字 value 混型）。
export function lunarMonthsOf (y) {
  const out = []
  const leap = leapMonth(y)
  for (let m = 1; m <= 12; m++) {
    out.push({
      value: String(m),
      text: MONTH_NAMES[m - 1] + '月',
      month: m,
      isLeap: false,
      days: lunarMonthDays(y, m)
    })
    if (leap === m) {
      out.push({
        value: m + 'l',
        text: '闰' + MONTH_NAMES[m - 1] + '月',
        month: m,
        isLeap: true,
        days: leapDays(y)
      })
    }
  }
  return out
}

// 农历 (y, m[, 闰]) → 公历 { y, m, d }。非法组合（超出历表域、日大于当月天数、
// isLeap 与该年闰月不符）返回 null，由调用方处理——表单层的兜底是「提交按钮
// disabled」（birthday computed 返回 ''）。
export function lunarToSolar (y, m, d, isLeap) {
  if (y < 1900 || y > 2100) return null
  if (m < 1 || m > 12) return null
  const md = lunarDaysOf(y, m, !!isLeap)
  if (md < 0 || d < 1 || d > md) return null

  // 距农历 1900 年正月初一的天数偏移
  let offset = 0
  for (let i = 1900; i < y; i++) offset += lunarYearDays(i)
  let leapAdded = false
  for (let i = 1; i < m; i++) {
    const leap = leapMonth(y)
    // 目标月之前若已扫过该年闰月位置，先把闰月天数补进偏移（只补一次）
    if (!leapAdded && leap > 0 && leap <= i) {
      offset += leapDays(y)
      leapAdded = true
    }
    offset += lunarMonthDays(y, i)
  }
  // 目标本身是闰月：先补「闰 X 月之前那个平 X 月」的天数（注意取平月
  // 长度 lunarMonthDays，不是闰月长度——与上游实现 day=monthDays(y,m) 同式）
  if (isLeap) offset += lunarMonthDays(y, m)

  // 农历 1900-1-1 = 公历 1900-01-31。锚点写成 Date.UTC(1900, 1, 30)（即
  // 1900-03-02）再减 31+30 天，与上游实现逐字节同式，便于对照校验。
  const t = Date.UTC(1900, 1, 30, 0, 0, 0) + (offset + d - 31) * 86400000
  const cal = new Date(t)
  return {
    y: cal.getUTCFullYear(),
    m: cal.getUTCMonth() + 1,
    d: cal.getUTCDate()
  }
}
